import { render } from "./AudienceAddSerieButton.vue?vue&type=template&id=6162a32e&scoped=true"
import script from "./AudienceAddSerieButton.vue?vue&type=script&lang=js"
export * from "./AudienceAddSerieButton.vue?vue&type=script&lang=js"

import "./AudienceAddSerieButton.vue?vue&type=style&index=0&id=6162a32e&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6162a32e"]])

export default __exports__